import { useMutation, UseMutationOptions, useQueryClient } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { documentSuggestionsApi } from 'src/Services/API';

export const useRejectDocumentSuggestion = (
  options?: UseMutationOptions<void, unknown, string>
) => {
  const assetId = useCurrentAssetId();
  const queryClient = useQueryClient();

  return useMutation<void, unknown, string>(
    'reject-document-suggestion',
    async suggestionId => {
      if (!assetId) {
        throw new Error('No asset selected');
      }
      await documentSuggestionsApi.documentClassificationControllerReject(assetId, suggestionId);
    },
    {
      ...options,
      onSettled: (data, error, variables, context) => {
        options?.onSettled?.(data, error, variables, context);
        queryClient.invalidateQueries({ queryKey: ['document-suggestions', assetId] });
      },
    }
  );
};
